import { cn } from 'app/lib/utils'
import { TreatmentCard } from './treatmentFixture'
import { STATUS_META, STATUS_ORDER, statusTotals } from './treatmentDisplay'

/** How far through their treatment this patient is, as one proportioned bar. */
export function SplitBar({ card, className }: { card: TreatmentCard; className?: string }) {
  const totals = statusTotals(card)
  const sum = STATUS_ORDER.reduce((acc, key) => acc + totals[key], 0)
  if (sum <= 0) return null
  return (
    <div className={cn(`flex h-1.5 overflow-hidden rounded-full bg-surface-muted`, className)}>
      {STATUS_ORDER.map((key) =>
        totals[key] > 0 ? (
          <div
            key={key}
            className={cn(`h-full`, STATUS_META[key].bar)}
            style={{ width: `${(totals[key] / sum) * 100}%` }}
          />
        ) : null,
      )}
    </div>
  )
}
